import type { ApiClient } from '../client';
import { DeliveryStatesResponseSchema } from '../schemas/deliveryStates';

// Every state a «Entrega» can be in — the only source of the state filter's options, which is what
// makes an option that matches nothing structurally impossible.
//
// The catalog is global: not scoped to a building, a window or a carrier, so the read takes no
// parameters and there is no query string to build. The client attaches the Firebase token via the
// Authorization header.
//
// Returns the BARE states rather than the envelope, exactly as the carriers read does: what the
// caller wants is the list, and handing it a wrapper only invites two ways to read one thing.
// Parsed here, at the boundary, so a malformed answer fails closed instead of half-filling a
// dropdown — and the schema is strict, so an envelope that grew a key stops the read.
export async function fetchDeliveryStates(client: ApiClient): Promise<string[]> {
  const data = await client.get<unknown>('/app_service/panel/v1/deliveries/states');
  return DeliveryStatesResponseSchema.parse(data).states;
}
